import { useContext } from 'react';
import './orgHeadDrop.css';
import { OrgAuthContext } from '../../../../context/OrgAuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { getType } from '../../../../utils/getType';

export default function OrgHeadDrop({ linkClick, setHeadDrop }) {
    const navigate = useNavigate();
    const { orgLogoutFun } = useContext(OrgAuthContext);
    const pathParts = window.location.pathname.split('/');

    const type = ['a', 'c', 'g'].includes(pathParts[2]) ? pathParts[2] : 'trip';

    return (
        <div className='orgHeadDropDiv' onClick={(e) => e.stopPropagation()}>
            {/* <Link
                className="orgTabsHeading add-btn"
                to="/org/create/room"
                onClick={() => linkClick('create-room')}
            >
                Create Room
            </Link> */}
            <Link
                className='orgTabsHeading add-btn'
                to={`/org/${type}/create/pack`}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                    linkClick('create-package');
                    setHeadDrop(false);
                }}
            >
                Create Package
            </Link>
            <button
                type='button'
                onClick={() => {
                    type === 'trip' ? navigate(`/org/account`) : navigate(`/org/${type}/account`);
                    setHeadDrop(false);
                }}
                name='account'
                className='orgHeadDropBtn'
            >
                Account
            </button>
            <button
                type='button'
                name='logOut'
                className='orgHeadDropBtn'
                onClick={() => {
                    orgLogoutFun();
                    setHeadDrop(false);
                }}
            >
                Log Out
            </button>
            <button
                type='button'
                name='contactUs'
                className='orgHeadDropBtn'
                onClick={() => {
                    navigate('/org/contact-us');
                    setHeadDrop(false);
                }}
            >
                Contact Us
            </button>
        </div>
    );
}
